<template>
	<div class="container">
		<div
			v-for="(item, idx) in props.data"
			:key="idx"
			class="container_item cursor-pointer"
			@click="onClickCard(item.title)"
		>
			<component :is="item.icon" />
			<span>{{ item.title }}</span>
		</div>
	</div>
</template>
<script setup lang="ts">
import { useRouter } from 'vue-router';

import { HotRankMainGridType } from '@/constants/menu';
import { CANCEL, CONFIRM_LOGIN, LOGIN_REQUIRED_PAGE } from '@/constants/title';
import { useHeaderStore } from '@/stores/header';
import { useLoginPopupStore } from '@/stores/LoginPopup';
import { useTokenStore } from '@/stores/token';

const router = useRouter();
const props = defineProps<{
	data: HotRankMainGridType[];
}>();

const tokenStore = useTokenStore();
const loginPopupStore = useLoginPopupStore();
const headerStore = useHeaderStore();

const onClickCard = async (item: string) => {
	if (!tokenStore.isLogin) {
		loginPopupStore.openPopup({
			icon: 'alert',
			content: LOGIN_REQUIRED_PAGE,
			confirm: () => router.push('/auth/login'),
			confirmText: CONFIRM_LOGIN,
			cancelText: CANCEL,
		});
		return;
	}

	const country = headerStore.getCountry;
	if (item === '섹터') {
		if (country === 'JPN') router.push(`/sector/jpn/${item}`);
		else router.push(`/sector/usa/${item}`);
	} else {
		// ETF 목록으로 이동
		router.push(`/etf/list/${item}`);
	}
};
</script>

<style lang="scss" scoped>
.container {
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	gap: 1rem;
	&_item {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		gap: 1rem;
		padding: 1.6rem;
		background-color: var(--color-bg-mid);
		border-radius: 0.8rem;
		height: 12.3rem;
		span {
			font-size: var(--font-s-regular);
			font-weight: var(--font-w-semi-bold);
			line-height: 2.1rem;
		}
	}
}
</style>
